<template>
    <div class="upload-content">
        <Form ref="dataForm" :model="formData" :labelWidth="50">
            <FormItem label="渠道" prop="channelId" :rules="required">
                <Select v-model="formData.channelId" filterable>
                    <Option
                        v-for="item in getAccountList"
                        :key="item.value"
                        :value="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </FormItem>
        </Form>
        <compMutiUpload
            v-bind="getFileProps"
            @on-success="success"
            @on-cancel="cancel"
        ></compMutiUpload>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpUploadFile } from "@/service/aftersales/aftersales";
export default {
    props: [],
    data() {
        let templateType = "RETURN_ORDER";
        return {
            formData: {
                templateType: templateType,
            },
            required: {
                required: true,
                message: "请填写必填项",
            },
        };
    },
    created() {},
    computed: {
        ...mapGetters("dictionary", ["getAccountList"]),
        getFileProps() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                data: {
                    srcLabel: 0,
                    model: "template_import",
                    type: "other",
                },
                name: "multipartFile",
                beforeUpload: this.beforeUpload,
                formatter: (res, item) => {
                    return res;
                },
            };
        },
    },
    methods: {
        cancel() {
            this.$emit("on-close");
        },
        async beforeUpload(res) {
            let flag = true;
            await this.$refs.dataForm.validate((valid) => {
                if (!valid) flag = false;
            });
            return flag;
        },
        success(res) {
            HttpUploadFile({
                channelId: this.formData.channelId,
                templateType: this.formData.templateType,
                meta: JSON.stringify(res.data),
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
    },
};
</script>
<style></style>
